<template>
    <v-list-group 
      :value="true"
      class="filter-group"
    >
      <template v-slot:activator>
        <v-list-item-title class="filter-section-title">{{title}}</v-list-item-title>
      </template>

      <div
        v-for="filter in filters"
        :key="filter.key"
      >
        <v-list-item
          v-if="!filter.children || !filter.children.length"
          @click="filterClick(filter.key)"
          class="filter-sub-item"
        >
          <v-simple-checkbox @click="filterClick(filter.key)" disabled class="filter-checkbox" :value="filterSelected(filter.key)"></v-simple-checkbox>
          <v-list-item-title v-text="filter.title" class="filter-sub-item-title"></v-list-item-title>
        </v-list-item>

        
        <v-list-group
          v-if="filter.children && filter.children.length"
          :value="false"
          sub-group
        >
          <template v-slot:activator>
            <v-list-item-title class="filter-section-archived-title">{{ filter.title }}</v-list-item-title>
          </template>

          <v-list-item
            v-for="filterChild in filter.children"
            :key="filterChild.key"
            @click="filterClick(filterChild.key)"
            class="filter-sub-sub-item"
          >
            <v-simple-checkbox @click="filterClick(filterChild.key)" disabled class="filter-checkbox" :value="filterSelected(filterChild.key)"></v-simple-checkbox>
            <v-list-item-title v-text="filterChild.title" class="filter-sub-item-title"></v-list-item-title>
          </v-list-item>

        </v-list-group>
      </div>
    </v-list-group>
</template>

<style scoped>
  @import '../../assets/styles/global-styles.css';
  @import '../../assets/styles/variables.css';

  .filter-section-title {
    font-weight: bold;
    color: var(--dark-text-color);
    font-size: 1em !important;
    padding: 8px 0;
  }

  .filter-sub-item {
    margin-left: 0px;
  }

  .filter-sub-sub-item {
    padding-left: 25px !important;
  }

  .filter-sub-item-title {
    color: var(--dark-text-color);
  }

  .filter-section-archived-title {
    color: var(--dark-text-color);
    font-size: 1em !important;
    padding: 8px 0;
  }


  .filter-group >>> .v-list-group__header {
    padding: 0 4px;
  }

  .filter-group >>> .v-list-item__icon.v-list-group__header__append-icon {
    min-width: 24px !important;
    margin-left: 0 !important;
  }

  .filter-group >>> .v-list-item {
    min-height: 36px;
  }

  .filter-group >>> .v-list-group__header {
    min-height: 36px;
    padding-left: 10px;
  }

  .filter-group >>> .v-list-group__header__prepend-icon {
    margin-top: auto !important;
    margin-bottom: auto;
  }


  .filter-checkbox {
    cursor: pointer !important;
  }

  .filter-checkbox >>> .theme--light.v-icon.v-icon.v-icon--disabled{
    color: var(--primary-background-color) !important;
  }
</style>


<script lang="ts">
  import { Filter } from '@/interfaces/Filter';
  import { AuthenticationService } from '@/services/authentication.service';
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

  /**
   * @desc section de filtre contenant plusieurs filtres !
   */
  @Component({
    components: {},
  })
  export default class FilterSection extends Vue {

    // titre du filtre
    @Prop({default: "filtre"})
    title? : string;

    // liste des filtres
    @Prop({default: []})
    filters? : Filter[];

    // liste des filtres selectionnés
    selectedFilters: string[] = [];

    /**
     * @desc ajoute / retire le filtre indiqué de la liste des filtre
     */
    private filterClick(filterKey: string) : void {
      const index = this.selectedFilters.findIndex(x => x === filterKey);
      if(index > -1) {
        this.selectedFilters.splice(index, 1);
        this.$emit("filterSelected", filterKey, false);
      }
      else {
        this.selectedFilters.push(filterKey);
        this.$emit("filterSelected", filterKey, true);
      }

    }

    /**
     * @desc retourne si oui ou non un filtre est selectionné
     */
    private filterSelected(filterKey: string) : boolean {
      return this.selectedFilters.includes(filterKey);
    }
  }
</script>
